import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonDepositos from "../Compuestos/Combos/ComboAbmZonDepositos";
import { function_ABM_ZON_Ubicaciones_Generar_JSON, function_ABM_ZON_Ubicaciones_Insertar, function_ABM_ZON_Ubicaciones_Leer, function_ABM_ZON_Ubicaciones_Modificar } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Ubicaciones";

const ABM_ZON_Ubicaciones = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [valorCodigoDeposito, setValorCodigoDeposito] = useState(null);

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_ZON_Ubicaciones_Generar_JSON(
        datos.CodigoUbicacion, datos.CodigoDeposito,
        datos.Descripcion,
        datos.IdCliente,
        datos.IdProveedor,
        datos.ArticulosReservadosClientes,
        datos.ArticulosExcluidosStockVenta
      )

      console.log(JSON)
      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_ZON_Ubicaciones_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_ZON_Ubicaciones_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.CodigoUbicacion)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const onValueChangedCodigoDeposito = (e) => {
    setValorCodigoDeposito(e.value)
    datos.CodigoDeposito = e.value;
  }

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoUbicacion: '',
            Descripcion: '',
            IdCliente: 0,
            IdProveedor: 0,
            ArticulosReservadosClientes: false,
            ArticulosExcluidosStockVenta: false
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_ZON_Ubicaciones_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <GroupItem caption="General">
        <SimpleItem dataField="CodigoUbicacion" >
          <Label text="Código" />
          <RequiredRule message="Indicar el Código es obligatorio." />
        </SimpleItem>
        <SimpleItem dataField="Descripcion">
          <Label text="Descripción" />
          <RequiredRule message="Indicar la Descripción es obligatorio." />
        </SimpleItem>

        <SimpleItem>
          <Label text="Depósito" />
          <ComboAbmZonDepositos
            value={valorCodigoDeposito}
            onValueChanged={onValueChangedCodigoDeposito} />
        </SimpleItem>

        <SimpleItem dataField="ArticulosExcluidosStockVenta" editorType="dxCheckBox" >
          <Label text="Ubicación de Artículos Excluidos de Stock de Venta" />
        </SimpleItem>
        <SimpleItem dataField="ArticulosReservadosClientes" editorType="dxCheckBox" >
          <Label text="Ubicación de Artículos Reservados para Clientes" />
        </SimpleItem>
      </GroupItem>


      <GroupItem caption="Pertenencia">
        <SimpleItem dataField="IdCliente" >
          <Label text="Código de Cliente" />
        </SimpleItem>
        <SimpleItem dataField="IdProveedor" >
          <Label text="Código de Proveedor" />
        </SimpleItem>
      </GroupItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_ZON_Ubicaciones;